import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/market-top-performing.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { MarketCar } from "@/types/market";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for watchlists
  const mock = AxiosMock.getInstance();
  const uri = new RegExp("/carburate/market/decades/.+/top-performing/");
  mock.onGet(uri).reply(200, data);
}

export const getMarketDecadeTopPerforming = ({ decade }: { decade: string }) => {
  return api.get(`/carburate/market/decades/${decade}/top_performing/`) as Promise<MarketCar[]>;
};

export const getMarketDecadeTopPerformingQueryOptions = (decade: string) => {
  return queryOptions({
    queryKey: ["market", "decades", decade, "top-performing"],
    queryFn: () => getMarketDecadeTopPerforming({ decade }),
  });
};

type UseMarketDecadeTopPerformingOptions = {
  decade: string;
  queryConfig?: QueryConfig<typeof getMarketDecadeTopPerforming>;
};

export const useMarketDecadeTopPerforming = ({
  decade,
  queryConfig,
}: UseMarketDecadeTopPerformingOptions) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getMarketDecadeTopPerformingQueryOptions(decade),
    ...queryConfig,
  });
};
